import { NavTemplate, SearchArea } from 'components';

export function Search() {
  return (
    <NavTemplate>
      <SearchArea />
    </NavTemplate>
  );
}
